export default __webpack_public_path__ + "static/media/background.b91f80e5.png";